import { type ErrorCodeMap } from './types';

export const gdtErrorCodes: ErrorCodeMap = {
  INTEGRATION_GDT_FILE_ERROR: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_PARSE_ERROR: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_ENCODING_ERROR: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_INVALID_LINE_FORMAT: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_LENGTH_MISMATCH: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_MISSING_REQUIRED_FIELD: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_INVALID_RECORD_TYPE: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_NOT_ENABLED: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_NOT_CONFIGURED: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_PDF_ERROR: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_WATCHER_ERROR: 'desktop.errors.integration.gdt',
  INTEGRATION_GDT_INTERNAL: 'desktop.errors.integration.gdt',
};
